import { Injectable } from '@angular/core';

import { RidangoEpic, RidangoReduxAction } from '@ridango/core';

import { ActionsObservable } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { RealtimeService } from '../realtime.service';
import { RealtimeActions } from './realtime.actions';

@Injectable({
    providedIn: 'root',
})
export class RealtimeEpics implements RidangoEpic {
    constructor(private actions: RealtimeActions, private service: RealtimeService) {}

    register() {
        return [this.fetchShapes];
    }

    fetchShapes = (action$: ActionsObservable<any>) =>
        action$.ofType(RealtimeActions.FETCH_SHAPES).pipe(
            switchMap((action: RidangoReduxAction) => {
                return this.service.fetchShapesByTripId(action.payload).pipe(
                    map((shapes: any[]) => this.actions.setShapes(shapes)),
                    catchError((error) => of(this.actions.fetchShapesError(error)))
                );
            })
        );
}
